import { Backdrop, CircularProgress, Typography } from "@mui/material";
import React from "react";
import { useAppSelector } from "../../app/hooks";
import { selectIsLoggingOff } from "./authSlice";

const LoggingOffOverlay: React.FC = () => {
  const isLoggingOff = useAppSelector(selectIsLoggingOff);

  return (
    <Backdrop
      open={isLoggingOff}
      sx={{
        color: "text.primary",
        zIndex: (theme) => theme.zIndex.modal + 1000,
        flexDirection: "column",
        gap: 2,
        backgroundColor: "background.default",
      }}
    >
      <CircularProgress color="inherit" />
      <Typography variant="h6">Logging off...</Typography>
    </Backdrop>
  );
};

export default LoggingOffOverlay;
